/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_About_SingleInputs */

const en_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open an endpoint for its live route, a copy-paste cURL and a sample response.`)
};

const zh_hans1_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开任一接口，即可查看实时路由、可直接复制的 cURL 和示例响应。`)
};

const pt_br2_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra um endpoint para ver a rota ao vivo, um cURL pronto para copiar e um exemplo de resposta.`)
};

const es_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre un endpoint para ver su ruta en vivo, un comando cURL listo para copiar y una respuesta de ejemplo.`)
};

const fr_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez un endpoint pour voir sa route en direct, un cURL à copier-coller et un exemple de réponse.`)
};

const de_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne einen Endpoint für seine Live-Route, einen cURL-Aufruf zum Kopieren und eine Beispielantwort.`)
};

const ru_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте эндпоинт, чтобы увидеть рабочий маршрут, готовый cURL и пример ответа.`)
};

const it_platform_about_single = /** @type {(inputs: Platform_About_SingleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri un endpoint per vedere la sua rotta live, un cURL da copiare e incollare e una risposta di esempio.`)
};

/**
* | output |
* | --- |
* | "Open an endpoint for its live route, a copy-paste cURL and a sample response." |
*
* @param {Platform_About_SingleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_about_single = /** @type {((inputs?: Platform_About_SingleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_About_SingleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_about_single(inputs)
	if (locale === "pt-BR") return pt_br2_platform_about_single(inputs)
	if (locale === "es") return es_platform_about_single(inputs)
	if (locale === "fr") return fr_platform_about_single(inputs)
	if (locale === "de") return de_platform_about_single(inputs)
	if (locale === "ru") return ru_platform_about_single(inputs)
	if (locale === "it") return it_platform_about_single(inputs)
	return en_platform_about_single(inputs)
});